/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - 认识新朋友，聊天，社交",
      "手机号码不正确",
      "Get the app",
      "使用Apple登录",
      "使用Facebook登录",
      "使用Google登录",
      "登入",
      "注册",
      "请输入​文字框​中​的​字符​以​继续。",
      "继续",
      "输入字符",
      "安全检查",
      "重新加载",
      "设置方便你​记忆​的​新密码。",
      "更新",
      "确认密码",
      "密码必须至少​包含​{{num}}个[[characters:num]]",
      "密码",
      "设置新密码",
      "Badoo—— The Blog",
      "工作机会",
      "聊天",
      "城市",
      "管理Cookies",
      "版权所有© 2006至今。Bumble。保留所有权力。",
      "Apple与Apple商标为Apple Inc.商标。{{__EOL__}}Google Play为Google LLC.商标。",
      "立即下载",
      "Facebook",
      "关注我们",
      "帮助中心",
      "Instagram",
      "语言",
      "LinkedIn",
      "总览",
      "Badoo属于Bumble Inc.",
      "隐私政策",
      "Safety Centre",
      "网站导览",
      "现代奴役法案声明",
      "条件与条款",
      "Twitter",
      "输入邮箱或手机号码。​我们​会将​重置​密码​的​步骤​发送​给你。",
      "设置新密码",
      "输入邮箱或手机号码",
      "忘记密码",
      "模特照片仅用于范例",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "无需​等待​配对。{{__EOL__}}{{__EOL__}}直接​进入​有​内容​的​聊天，​直接​收获​让​你​心动​的​瞬间，​结识​愿意​互相​了解​的人。",
      "开始聊天？",
      "注册表明​您​同意​我们的​<a class=\"link\" href=\"{{terms_url}}\">条款​与​条件</a>。用户​数据​使用​细则​请​查看​我们的​<a class=\"link\" href=\"{{privacy_url}}\">隐私政策</a>。",
      "帮你做​真实​的​自己，<br />​让你​收获​快乐​的​交友​经历。",
      "在约会中做​自信的自己",
      "或者",
      "已有账号？",
      "使用邮箱地址或手机号码注册",
      "在约会中收获你想要的。{{__EOL__}}无需致歉。",
      "只想单纯聊聊天？​我们理解。{{__EOL__}}想稳定下来？非常好。{{__EOL__}}{{__EOL__}}如果你改变了想法，没问题。",
      "约会",
      "寻找一段亲密关系",
      "聊天",
      "遇见抱有​同样​目的​的人。",
      "{{name}}，{{age}}岁",
      "保证您的安全是​我们的​首要​任务。",
      "Safety Centre是我们的​信息库，​查看​我们​为您​提供的​各种​交友​帮助，​让​您​安心​交友，​充满​信心。",
      "查看我们的 Safety Centre",
      "无论何时何地，<br/>安全都是第一位的。",
      "从我们相识的那一刻起，我以为事情会很顺利……",
      "一开始我​并不想​开始​一段​认真的​关系……",
      "如果要给使用Badoo的人一个建议的话，那就是做自己……",
      "Badoo成功故事",
      "查看更多成功故事",
      "{{num}}__CUT__评分",
      "Apple App Store",
      "相信我们，自2006年起，我们​促成了​数以​百万计的​人。",
      "{{num}}百万+__CUT__下载",
      "{{num}}百万+",
      "Google Play Store",
      "我们经验丰富",
      "使用邮箱或​手机​号码​登录",
      "输入密码",
      "忘记密码？",
      "注册",
      "没有账号？",
      "登录",
      "注册"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "字符"
            ],
            "singular": [
                  "字符"
            ]
      },
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小时"
            ],
            "singular": [
                  "小时"
            ]
      },
      "minute": {
            "plural": [
                  "分钟"
            ],
            "singular": [
                  "分钟"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
